import { Component } from '@angular/core';

@Component({
  selector: 'sf-not-found',
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
